import { useState, useEffect } from 'react';

export function useSidebar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktopCollapsed, setIsDesktopCollapsed] = useState(
    () => localStorage.getItem('sidebar-collapsed') === 'true'
  );

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Apply margin-left directly as inline style — most reliable approach.
  // Inline styles bypass any CSS cascade/specificity issues and still
  // trigger the CSS transition defined on the layout content elements.
  // isMobile is included as a dep so the effect re-runs on resize,
  // clearing inline styles when switching to mobile.
  useEffect(() => {
    const contentEls = document.querySelectorAll<HTMLElement>(
      '.layout > main, .layout > .card, .layout > .layout__content'
    );
    contentEls.forEach((el) => {
      el.style.marginLeft = !isMobile && isDesktopCollapsed ? '0px' : '';
    });
    localStorage.setItem('sidebar-collapsed', String(isDesktopCollapsed));
  }, [isDesktopCollapsed, isMobile]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDesktopSidebar = () => {
    setIsDesktopCollapsed((prev) => !prev);
  };

  return {
    isMobileMenuOpen,
    isMobile,
    toggleMobileMenu,
    closeMobileMenu,
    isDesktopCollapsed,
    toggleDesktopSidebar,
  };
}
